import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useEffect } from 'react';
import { useReducedMotion, useDidUpdate } from '@mantine/hooks';
import { useMantineTheme } from '@mantine/styles';
function useTransition(_ref) {
  var duration = _ref.duration,
    exitDuration = _ref.exitDuration,
    timingFunction = _ref.timingFunction,
    mounted = _ref.mounted,
    onEnter = _ref.onEnter,
    onExit = _ref.onExit,
    onEntered = _ref.onEntered,
    onExited = _ref.onExited;
  var theme = useMantineTheme();
  var shouldReduceMotion = useReducedMotion();
  var reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
  var _useState = useState(mounted ? "entered" : "exited"),
    _useState2 = _slicedToArray(_useState, 2),
    transitionStatus = _useState2[0],
    setStatus = _useState2[1];
  var transitionDuration = reduceMotion ? 0 : duration;
  var timeoutRef = useRef(-1);
  var handleStateChange = function handleStateChange(shouldMount) {
    var preHandler = shouldMount ? onEnter : onExit;
    var handler = shouldMount ? onEntered : onExited;
    setStatus(shouldMount ? "pre-entering" : "pre-exiting");
    window.clearTimeout(timeoutRef.current);
    transitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
    if (transitionDuration === 0) {
      typeof preHandler === "function" && preHandler();
      typeof handler === "function" && handler();
      setStatus(shouldMount ? "entered" : "exited");
    } else {
      var preStateTimeout = window.setTimeout(function () {
        typeof preHandler === "function" && preHandler();
        setStatus(shouldMount ? "entering" : "exiting");
      }, 10);
      timeoutRef.current = window.setTimeout(function () {
        window.clearTimeout(preStateTimeout);
        typeof handler === "function" && handler();
        setStatus(shouldMount ? "entered" : "exited");
      }, transitionDuration);
    }
  };
  useDidUpdate(function () {
    handleStateChange(mounted);
  }, [mounted]);
  useEffect(function () {
    return function () {
      return window.clearTimeout(timeoutRef.current);
    };
  }, []);
  return {
    transitionDuration: transitionDuration,
    transitionStatus: transitionStatus,
    transitionTimingFunction: timingFunction || theme.transitionTimingFunction
  };
}
export { useTransition };